import { ArrayDataSource } from './BaseDataSources';
import { Guid, IKeyValue } from '@samc/common';

export class ForwardCommitmentParentSource extends ArrayDataSource<IKeyValue<string, number>> {
  public constructor(sellerId: string | undefined) {
    super('/componentapi/transaction/forwardcommitment', {sellerId});
  }
}